import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { IntegrationStatRow } from '@feathr/components';

import type { TRaisersEdgeSyncSummaryResult } from './RaisersEdgeSyncSummary.utils';
import { getSyncSummaryStats } from './RaisersEdgeSyncSummary.utils';

interface IProps {
  /** `undefined` while the first load runs; `null` if it failed. */
  summary: TRaisersEdgeSyncSummaryResult | undefined;
}

function RaisersEdgeSyncSummary({ summary }: Readonly<IProps>): JSX.Element | null {
  const { t } = useTranslation();

  if (summary === undefined) {
    return null;
  }

  return (
    <IntegrationStatRow
      name={'raisers-edge-sync-summary'}
      stats={getSyncSummaryStats(summary, t)}
    />
  );
}

export default RaisersEdgeSyncSummary;
